import axios from "axios";
import qs from "qs";
import { api } from "@/plugins/util";

export function getinfo(){

    return axios.get(api+"/personal/info")
};

export function sendCode(userName){
    return axios.post(api + "/personal/sendcode",qs.stringify({userName}) );
};

export function change(userName,oldPassword,newPassword,code){
    return axios.get(api + "/personal/changePassword", {
        params: {
            userName,
            oldPassword,
            newPassword,
            code,
        }
    });
};

export function search(name){
    return axios.get(api+"/personal/search",{
          params:{
              name
          }
    });
};

export function sendMessage(receiveId,content){
    return axios.get(api+"/personal/addMessage",{
          params:{
            receiveId,
            content
          }
    });
};

export function getList(pageNum) {
    return axios.get(api + "/personal/findAll", {
        params: {
            pageNum,

        }
    });
}
export function setReaded(id) {
    return axios.get(api + "/personal/Readed", {
        params: {
           id,

        }
    });
}

export function nextStep(newUserName,userName,code){

    return axios.get(api+"/personal/nextStep",{
        params:{
            newUserName,
            userName,
            code,
        }
    })

}
export function newSendcode(){
    return axios.post(api+"/personal/newSendcode")

    }

export function transfer(newUserName,code){
    return axios.get(api+"/personal/transfer",{
       params:{
          newUserName,
          code
       }

    })



}
